import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/orderFxGainLossDetailedInfo', request)
}

export {get}
